<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="stockbatch_keyno" [ttModel]="menu.stockbatch_keyno" [ttButtons]="stockBatchButtons" ttReadonly></tt-input>
        <tt-input-number ttLabel="quantity" [ttModel]="menu.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input ttLabel="consignmentline_keyno" [ttModel]="menu.consignmentline_keyno" ttReadonly></tt-input>
        <tt-button *ngIf="menu.show_delete === '1'" ttText="consignmentlinesb_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
    </tt-card>
</tt-page>
